const allowedCharKey = [8, 46, 37, 38, 39, 40]
const allowedCommandKey = [65, 97, 67, 99, 86, 117, 88, 120]
const numberFilterOnKeyPress = (e: any) => {
    const keyCode = e.which || e.keyCode
    const charCode = e.charCode
    if (e.ctrlKey) {
        if (allowedCommandKey.indexOf(keyCode) >= 0)
            return true
    }
    if (allowedCharKey.indexOf(keyCode) >= 0)
        return true
    const value = String.fromCharCode(charCode)
    if (!/[0-9]/.test(value)) {
        e.preventDefault()
        return false
    } else
        return true
}

const inputNumberFilter = (e: any, setValue: any, name: string) => {
    var value = e.target.value
    value = value.replace(/[^0-9]/g, '')
    setValue(name, value)
}
export default numberFilterOnKeyPress